// src/components/store/sections/newsletter/NewsletterV27SplitcardOceanCyan.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV27SplitcardOceanCyan(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={27}
      archKey="split_card"
      archLabel="Floating Split Card"
      palName="OceanCyan"
      grad="from-cyan-500 via-sky-500 to-blue-700"
      lightBg="bg-cyan-50"
      textCol="text-cyan-700"
      borderCol="border-cyan-200"
      btnCls="bg-blue-600 hover:bg-blue-700"
      hexCol="#06b6d4"
      {...props}
    />
  );
}
